<template>
  <v-card class="px-2">
    <v-card-title>
      Company Profile
    </v-card-title>
    <v-card-subtitle>
      Update your company details at anytime
    </v-card-subtitle>
    <v-card-text class="py-0">
      <v-form ref="form" v-model="valid">
        <v-row dense>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="company.name"
              label="Company name"
              outlined
              maxlength="50"
              :rules="[$rules.required]"
              required
              :disabled="!allowSave"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="company.industryId"
              :items="industries"
              label="Industry"
              outlined
              item-text="name"
              item-value="id"
              :rules="[$rules.required]"
              required
              :disabled="!allowSave"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="company.employeeSizeId"
              :items="employeeSizes"
              label="# Of Employees"
              outlined
              item-text="name"
              item-value="id"
              :rules="[$rules.required]"
              required
              :disabled="!allowSave"
            ></v-select>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions v-if="allowSave" class="pt-0">
      <v-btn @click="save" :loading="saving">Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CompanyProfileForm",
  components: {},
  data: () => ({
    valid: true,
    saving: false
  }),
  computed: {
    allowSave() {
      return this.is_admin;
    },
    ...mapGetters({
      company: "company/company",
      industries: "lookup/industries",
      employeeSizes: "lookup/employee_sizes",
      is_admin: "profile/is_admin"
    })
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("company/saveCompany", this.company)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Company profile saved.");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your company information."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
